import React from 'react';

function BalanceGlobalEffect(): JSX.Element {
  return <></>;
}

export default React.memo(BalanceGlobalEffect);
